module.exports = __webpack_public_path__ + "img/シュー.7ab29fbd.jpeg";